'use client';
import AccordionItem from '@/Components/accordian';
import React, { useState } from 'react';

const FaqSection = ({ heading, subheading, faqs }) => {
  const [active, setActive] = useState(null);

  const handleToggle = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <div className='w-full flex flex-col justify-center items-center lg:px-20 lg:py-10 px-3 py-5 max-w-[1750px] mx-auto'>
      <div className='m-auto  pb-[6%] '>
        <h2 className='text-[#0000000D]/5 font-inter font-bold lg:text-8xl text-4xl'>{heading}</h2>
        
        
          <h3 className='text-[#172554] font-inter font-bold pb-6 lg:text-4xl text-2xl text-center'>{subheading}</h3>
        <div className='flex flex-col gap-6'>
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              active={active}
              handleToggle={handleToggle}
              faq={faq}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqSection; 